@if (canLoad) {
  <div class="update-my-ticket-box my-account-container" [ngClass]="isMobile? '':''">
    @if (!isMobile) {
      <div class="col-3 col-sm-3 my-account-left-nav">
        <app-my-account-left-sidenav [navState]="'SupportTicketNavNode'"></app-my-account-left-sidenav>
      </div>
    }
    <div [ngClass]="isMobile? 'col-12' :'col-9 col-sm-9 my-account-right-nav'">
      <h1 class="myProfileTopHeader m-0 update-block-title">
        {{'common.text_account_supportTicket_updateTicket_heading'|cxTranslate}}
      </h1>
      <div class="myProfileBody update-my-ticket-container">
        <div class="row col-no-padding">
          <div class="col-sm-6 item-wrapper update-my-ticket-wrapper">
            <div class="item-group">
              <div class="item-label"> Subject</div>
              <div class="item-value">
              {{Data?.subject}}</div>
            </div>
          </div>
          <div class="col-sm-6 item-wrapper update-my-ticket-wrapper">
            <div class="item-group">
              <div class="item-label">Ticket ID</div>
              <div class="item-value">{{Data?.ticketID}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 item-wrapper update-my-ticket-wrapper">
            <div class="item-group">
              <div class="item-label"> Date Updated</div>
              <div class="item-value">{{Data?.lastModificationDate2| date:'dd/MM/yyyy hh:mm'}}</div>
              <input type="hidden" class="hiddenUpdatedTicketDateInner"
                value="04/06/2024 11:30:16 AM +0100">
              </div>
            </div>
            <div class="col-sm-3 item-wrapper update-my-ticket-wrapper">
              <div class="item-group">
                <div class="item-label"> Date Created</div>
                <div class="item-value"> {{Data?.creationDate| date:'dd/MM/yyyy hh:mm'}}</div>
              </div>
            </div>
            <div class="col-sm-3 item-wrapper update-my-ticket-wrapper">
              <div class="item-group">
                <div class="item-label"> Status</div>
                <div class="item-value">
                  @for (state of status; track state) {
                    @if (state.code.toLowerCase() ==Data?.status?.id.toLowerCase()) {
                      <span
                      >{{state?.name}}</span>
                    }
                  }
                </div>
              </div>
            </div>
            <div class="col-sm-3 item-wrapper update-my-ticket-wrapper">
              <div class="item-group">
                <div class="item-label"> Category</div>
                <div class="item-value">{{Data?.kbecomTicketCategory?.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="messagePopupDiv pt-5 pb-2">
          <div class="msgText">{{'common.text_account_supporttickets_messages'|cxTranslate}}</div>
          <div class="popupOpener" (click)="openPopup()">
            {{'common.text_account_supporttickets_updateTicket_addMessage'|cxTranslate}}
          </div>
        </div>
        @for (data of Data?.ticketEvents; track data) {
          <div class="myProfileTopHeader mt-2 update-block-title">
            @if (data?.addedByAgent) {
              <b class="textCase">{{data?.displayText}}</b>
            } @else {
              <b class="textCase">{{data?.author}}</b>
              &nbsp;<span>{{'common.text_account_supporttickets_updateTicket_on'|cxTranslate}}</span>&nbsp;
              <span>{{data?.startDateTime| date:'dd/MM/yyyy hh:mm'}}</span>
            }
          </div>
          <div class="myTicketBody">
            <div class="p-3 update-my-ticket-details">{{data?.text}}</div>
            @if (data?.attachments?.length>0 && data?.attachments[0]?.URL) {
              <div class="p-3">
                <a [href]="baseUrl+data?.attachments[0]?.URL"><img src="/icons/attachment.svg" width="20px"></a>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }